import './new-leave-subcategory.scss';

import { useNavigate } from "react-router-dom";
import { zodResolver } from "@hookform/resolvers/zod";
import { FieldErrors, FormProvider, useForm } from "react-hook-form";
import { FaChevronLeft } from "react-icons/fa6";
import { Button } from "primereact/button";

import { MessageResponseDto } from "@api/api";
import { useFormApiMapper } from "@core/services/form-api-mapper.hook";
import { useQyCreateLeaveSubcategory } from "@core/query/leave-subcategory.query";
import { LeaveSubcategoryFormRule, LeaveSubcategoryFormSchema } from "@core/form/form.rule";
import { leaveSubcategoryFormDefault } from "@core/form/form.default";
import { getFormErrorMessage } from "@core/utility/get-error-message";
import { useNotificationContext } from "@shared/ui/notification/notification.context";
import HeaderContent from "@shared/ui/header-content/header-content";
import FormLeaveSubcategory from "../form-leave-subcategory/form-leave-subcategory";

export function LeaveSubcategory() {
  // LOCAL DECLARATION
  const navigate = useNavigate();
  const { mapCreateLeaveSubcategory } = useFormApiMapper();
  const { showError, showSuccess, showWarning } = useNotificationContext();

  // QUERIES
  const handleApiSuccess = (response: MessageResponseDto) => {
    const data = response.data as any;

    showSuccess(`New LeaveSubcategory is created`);
    navigate(`../${data.code}`);
  };
  const { mutate: addLeaveSubcategory, isLoading: isCreating } =
    useQyCreateLeaveSubcategory(handleApiSuccess);

  // LOCAL FUNCTIONS
  const formMethod = useForm<LeaveSubcategoryFormSchema>({
    defaultValues: leaveSubcategoryFormDefault,
    resolver: zodResolver(LeaveSubcategoryFormRule),
  });
  const { handleSubmit } = formMethod;

  const handleValidate = (form: LeaveSubcategoryFormSchema) => {
    const formData = mapCreateLeaveSubcategory(form);
    addLeaveSubcategory(formData);
  };
  const handleValidateError = (err: FieldErrors<LeaveSubcategoryFormSchema>) => {
    const formMessage = getFormErrorMessage(err);
    showError(formMessage);
  };

  return (
    <div id="LeaveSubcategory" className="leave-subcategory">
      <HeaderContent
        title="New Leave Subcategory"
        backIcon={<FaChevronLeft />}
        onBack={() => navigate("../")}
      >
        <Button
          className="w-full block"
          label="Save"
          disabled={isCreating}
          onClick={handleSubmit(handleValidate, handleValidateError)}
        ></Button>
      </HeaderContent>

      <div className="p-7">
        <FormProvider {...formMethod}>
          <section className="grid grid-cols-1 md:grid-cols-2 gap-2 mb-4 bg-white">
            <FormLeaveSubcategory />
          </section>
        </FormProvider>
      </div>
    </div>
  );
}

export default LeaveSubcategory;